import { setOpenModal } from "@/lib/ui/actions/actions";
import { uiContext } from "@/components/UiProvider";
import { useContext } from "react";
import { useCallback } from "react";

const useModal = () => {
  const { uiDispatch } = useContext(uiContext);
  return useCallback(
    (params) => uiDispatch(setOpenModal(params)),
    [uiDispatch]
  );
};

export default useModal;
